type PermissionState = NotificationPermission | 'unsupported';

type NotificationTone = {
  shortLabel: string;
  title: string;
  description: string;
  intent: 'danger' | 'neutral' | 'success' | 'warning';
};

export function getNotificationTone(permission: PermissionState, isSupported: boolean): NotificationTone {
  if (!isSupported || permission === 'unsupported') {
    return {
      shortLabel: 'Unavailable',
      title: 'Notifications unavailable',
      description: 'This browser does not currently expose web notification permissions.',
      intent: 'warning',
    };
  }

  if (permission === 'granted') {
    return {
      shortLabel: 'Enabled',
      title: 'Alerts enabled',
      description: 'This device is ready for future emergency notification flows.',
      intent: 'success',
    };
  }

  if (permission === 'denied') {
    return {
      shortLabel: 'Blocked',
      title: 'Alerts blocked',
      description: 'Notifications are blocked in browser settings for this device.',
      intent: 'danger',
    };
  }

  return {
    shortLabel: 'Pending',
    title: 'Alerts not enabled',
    description: 'Enable notifications now so the next implementation can add push delivery.',
    intent: 'neutral',
  };
}
